module.exports = "<app-landprocurement-menu></app-landprocurement-menu>\n<!-- <div class=\"clearfix\"></div> -->\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/landprocurement.component.html
// module id = ./src/app/landprocurement/landprocurement.component.html
// module chunks = main